export enum CookieKeys {
  AccessToken = "token",
  ReturnUrl = "returnUrl",
  RefreshToken = "refreshToken",
  DeviceId = "DeviceId",
}
